import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { WebLayout } from 'components/Layout';
import { ArrowRightIcon, MailIcon } from '@heroicons/react/outline';

export const JoinWaitingList = () => {
  const [email, setEmail] = useState('');

  const handleWhatsAppJoin = () => {
    const encoded = encodeURIComponent(
      `Hello Fundo Team! I'd love to join the mobile app beta waiting list.\n\nMy email is: ${
        email || 'N/A'
      }`
    );
    window.open(`https://wa.me/256782692271?text=${encoded}`, '_blank');
  };

  return (
    <WebLayout>
      <section
        className="
        min-h-[85vh] flex flex-col items-center justify-center px-6 text-center
        relative overflow-hidden
      "
      >
        {/* Background Glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-green-100 via-white to-emerald-100 opacity-70"></div>

        {/* Decorative floating shapes */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 0.12, y: 0 }}
          transition={{ duration: 1 }}
          className="absolute top-16 right-12 w-40 h-40 rounded-full bg-green-300 blur-3xl"
        ></motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 0.12, y: 0 }}
          transition={{ duration: 1 }}
          className="absolute bottom-20 left-10 w-48 h-48 rounded-full bg-emerald-300 blur-3xl"
        ></motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative z-10 max-w-3xl"
        >
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
            Be the First to Experience
            <br />
            <span className="text-green-700">Fundo Mobile App</span>
          </h1>

          <p className="mt-6 text-gray-600 text-lg max-w-2xl mx-auto">
            We're building a powerful mobile app to help farmers manage their farms, access funding,
            join their SACCO, and trade in the open market.
            <br />
            Join the waiting list and get early access during our private beta launch.
          </p>

          {/* EMAIL INPUT */}
          <div className="mt-10 max-w-md mx-auto">
            <label className="block text-gray-700 text-sm font-medium mb-2">
              Enter Email (optional)
            </label>

            <div
              className="
              flex items-center rounded-2xl overflow-hidden bg-gray-100 border
              focus-within:ring-2 focus-within:ring-green-600 transition
            "
            >
              <MailIcon className="h-5 w-5 text-green-700 ml-3" />
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-3 py-3 bg-transparent outline-none text-gray-700"
              />
            </div>

            <p className="text-xs text-gray-500 mt-2">
              We’ll include your email when opening WhatsApp.
            </p>
          </div>

          {/* WHATSAPP CTA */}
          <motion.button
            onClick={handleWhatsAppJoin}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="
              mt-8 px-8 py-4 rounded-full
              bg-green-700 text-white font-semibold text-lg
              shadow-xl shadow-green-300 mx-auto
              flex items-center justify-center gap-3
            "
          >
            Join via WhatsApp
            <ArrowRightIcon className="h-5 w-5" />
          </motion.button>

          {/* Social Proof */}
          <p className="mt-6 text-gray-500 text-sm">
            🎉 2,300+ farmers and supporters already joined the waiting list.
          </p>

          {/* Privacy */}
          <p className="mt-2 text-xs text-gray-400">No spam. No ads. Only early access updates.</p>
        </motion.div>
      </section>
    </WebLayout>
  );
};
